import { render } from "./EditPasswordModal.vue?vue&type=template&id=7506cd40&scoped=true"
import script from "./EditPasswordModal.vue?vue&type=script&lang=js"
export * from "./EditPasswordModal.vue?vue&type=script&lang=js"

import "./EditPasswordModal.vue?vue&type=style&index=0&id=7506cd40&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7506cd40"]])

export default __exports__